module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="container container-properties-item">\n    <div class=\'picture\'>\n        ';
 if (image) { ;
__p += '\n            <img src=\'' +
__e( image ) +
'\'/>\n            <div class="no-image hide" title="Product image failed to load: \'' +
__e( image ) +
'\'">Failed to load</div>\n        ';
 } else { ;
__p += '\n            <div class="no-image">No image</div>\n        ';
 } ;
__p += '\n    </div>\n    <div class=\'details\'>\n        ';
 if (name) { ;
__p += '\n        <div>\n            <div class=\'overflow product-name\'>' +
__e( name ) +
' </div>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (productID) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Id: ' +
__e( productID ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (brand) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Brand: ' +
__e( brand ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (price) { ;
__p += '\n        <div>\n            <span class=\'overflow\'> ' +
__e( price ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (availability) { ;
__p += '\n        <div>\n            <span class=\'overflow\'>Availability: ' +
__e( availability ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n        ';
 if (description) { ;
__p += '\n        <div>\n            <span class=\'wrap\'>Description: ' +
__e( description ) +
' </span>\n        </div>\n        ';
 } ;
__p += '\n\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/salesforceCommerceWidget/view/SalesforceCommerceProductView.tpl
// module id = 1022
// module chunks = 0